import { MENU_LOAD, LAZY_MENU_LOADED } from './types';

export default {
  /**
   * Save menu data in store
   * @param state
   * @param products
   * @param categories
   * @param items
   * @param modifiers
   */
  [MENU_LOAD]: (state, {
    products,
    categories,
    items,
    modifiers,
  }) => {
    state.products = products;
    state.categories = categories;
    state.items = items;
    state.modifiers = modifiers;
  },
  [LAZY_MENU_LOADED]: (state, resp) => {
    const lazyMenu = resp.data;

    const updatedMenu = lazyMenu.map((menuItem) => {
      const items = menuItem.items.map(item => ({
        categoryKey: item.categoryId,
        glutenFree:  item.glutenFree,
        itemKey:     item.id,
        quantity:    item.itemQuantity,
        modifiers:   item.modifiers,
        vegan:       item.vegan,
      }));

      return {
        ...menuItem,
        items,
      };
    });

    state.lazyMenu = updatedMenu;
  },
};



// WEBPACK FOOTER //
// ./src/apps/menu/store/mutations.js